// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"b4fab5e7","396":"00cee4e3","400":"ca3ed633","460":"23313bfa","625":"012cfde9","634":"ff619906","933":"fbcf1026"}[chunkId] + ".chunk.js";
};